"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@emotion/react");
var _Text = _interopRequireDefault(require("../../Text"));
var _styles = require("./styles");
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** @jsxImportSource @emotion/react */

const TimelineStep = ({
  title,
  text,
  active,
  complete
}) => {
  const theme = (0, _react2.useTheme)();
  return (0, _jsxRuntime.jsxs)(_styles.Wrapper, {
    theme: theme,
    children: [(0, _jsxRuntime.jsx)(_styles.Circle, {
      css: theme => [_styles.styles.defaultCircle(theme), active && _styles.styles.active, complete && _styles.styles.complete]
    }), (0, _jsxRuntime.jsxs)(_styles.TextWrapper, {
      children: [(0, _jsxRuntime.jsx)(_Text.default, {
        semibold: true,
        size: "16px",
        children: title
      }), (0, _jsxRuntime.jsx)(_Text.default, {
        size: "15px",
        children: text
      })]
    })]
  });
};
var _default = exports.default = TimelineStep;